import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="21" height="25" viewBox="0 0 21 25" {...props}><path d="M19.5 3H16V2h-3.6v-.1c0-1.1-.9-1.9-1.9-1.9-1.1 0-1.9.9-1.9 1.9V2H5v1H1.5C.7 3 0 3.7 0 4.5v19c0 .8.7 1.5 1.5 1.5h18c.8 0 1.5-.7 1.5-1.5v-19c0-.8-.7-1.5-1.5-1.5zm.5 20.5c0 .3-.2.5-.5.5h-18c-.3 0-.5-.2-.5-.5v-19c0-.3.2-.5.5-.5H5v3h11V4h3.5c.3 0 .5.2.5.5v19z" fill="#1680AB" /></svg>);